const clientExtensionBridge = require("./clientExtensionBridge.js");
const vA249 = ["spinnerIndex", "bundle"];
const vF22 = (p5486, p5487) => {
  try {
    const vO127 = {
      screen: p5486.id.toLowerCase()
    };
    if (p5487) {
      vA249.forEach(p5488 => {
        if (p5488 in p5487) {
          vO127.screen_data = vO127.screen_data || {};
          vO127.screen_data[p5488] = p5487[p5488];
        }
      });
    }
    logEventFRVR("view_screen", vO127);
  } catch (e38) {
    console.error(e38);
  }
};
const vA250 = [];
const vA251 = [];
const vA252 = [];
const vA253 = [];
let v4667 = false;
let v4668 = false;
let allowNavigation = FRVR.channelCharacteristics.allowNavigation;
export function buildViews() {
  const v4670 = vA250.length > 0 ? vA250[vA250.length - 1] : null;
  const v4671 = vA251.length > 0 ? vA251[vA250.length - 1] : {};
  const v4672 = vA252.length > 0 ? vA252[vA250.length - 1] || {} : {};
  const vO128 = {};
  if (!v4670) {
    return [];
  }
  vO128[vA250.length - 1] = true;
  let vA254 = [];
  if (v4672.translucent) {
    for (let v4673 = vA250.length - 2; v4673 >= 0 && (vA254.push(m(vA250[v4673], vA251[v4673])), vO128[v4673] = true, vA252[v4673] && vA252[v4673].translucent === true); --v4673) {
      ;
    }
  }
  for (let v4674 = vA250.length - 2; v4674 >= 0; --v4674) {
    if (vA252[v4674] && vA252[v4674].keepAlive === true && !vO128[v4674]) {
      vA254.push(m(vA250[v4674], vA251[v4674]));
      vO128[v4674] = true;
    }
  }
  vA254.reverse();
  vA254.push(m(v4670, v4671));
  return vA254;
}
export function getCurrentView() {
  if (vA250.length > 0) {
    return vA250[vA250.length - 1];
  } else {
    return null;
  }
}
export function navigateTo(p5489, p5490, p5491) {
  if (vA250.indexOf(p5489) === -1) {
    vF22(p5489, p5490);
    vA250.push(p5489);
    vA251.push(p5490 || {});
    vA252.push({
      ...p5489.defOpts,
      ...p5491
    });
    vA253.push(f720);
    if (allowNavigation) {
      history.pushState({
        url: p5489.id,
        id: vA253.length
      }, null, "");
    }
    m.redraw();
  }
}
function f715(p5492, p5493) {
  if (p5492.length != p5493.length) {
    return false;
  }
  for (let vLN0728 = 0; vLN0728 < p5492.length; vLN0728++) {
    if (p5492[vLN0728] !== p5493[vLN0728]) {
      return false;
    }
  }
  return true;
}
function f716(p5494, p5495) {
  return p5494 === p5495 || !!p5494 && !!p5495 && !!f715(Object.keys(p5494), Object.keys(p5495)) && !!f715(Object.values(p5494), Object.values(p5495));
}
export function navigateReplaceAll(p5496, p5497, p5498) {
  const v4675 = vA250.indexOf(p5496);
  if (v4675 === -1 || !f716(vA252[v4675], p5498)) {
    vA250.splice(0, 0, p5496);
    vA251.splice(0, 0, p5497 || {});
    vA252.splice(0, 0, p5498);
    vA253.splice(0, 0, f720);
    if (allowNavigation) {
      history.pushState({
        url: p5496.id,
        id: vA253.length
      }, null, "");
    }
    for (let vLN179 = 1; vLN179 < vA250.length;) {
      if (!vA252[vLN179] || vA252[vLN179].preventReplace !== true) {
        vA250.splice(vLN179, 1);
        vA251.splice(vLN179, 1);
        if (checkForMethod(vA253[vLN179].toString())) {
          vA253[vLN179]();
        }
        vA253.splice(vLN179, 1);
        const v4676 = vA252.splice(vLN179, 1);
        const v4677 = v4676[0];
        if (v4677 && v4677.onPop) {
          v4677.onPop();
        }
      } else {
        ++vLN179;
      }
    }
    m.redraw();
  }
}
export function navigateBackAll() {
  for (let vLN0729 = 0; vLN0729 < vA250.length;) {
    if (!vA252[vLN0729] || vA252[vLN0729].preventReplace !== true) {
      vA250.splice(vLN0729, 1);
      vA251.splice(vLN0729, 1);
      if (checkForMethod(vA253[vLN0729].toString())) {
        vA253[vLN0729]();
      }
      vA253.splice(vLN0729, 1);
      const v4678 = vA252.splice(vLN0729, 1);
      const v4679 = v4678[0];
      if (v4679 && v4679.onPop) {
        v4679.onPop();
      }
    } else {
      ++vLN0729;
    }
  }
  m.redraw();
}
export function navigateReplaceTop(p5499, p5500, p5501) {
  if (vA253.length > vA250.length) {
    const v4680 = vA253.length > 0 ? vA253[vA253.length - 1] : null;
    if (checkForMethod(v4680.toString())) {
      v4680();
    }
  }
  if (vA250.length > 0) {
    vA250.pop();
    vA251.pop();
    vA253.pop();
    const v4681 = vA252.pop();
    if (v4681 && v4681.onPop) {
      v4681.onPop();
    }
    m.redraw();
  }
  if (vA250.indexOf(p5499) === -1) {
    vA250.push(p5499);
    vA251.push(p5500 || {});
    vA252.push(p5501);
    vA253.push(f720);
    if (allowNavigation) {
      history.pushState({
        url: p5499.id,
        id: vA253.length
      }, null, "");
    }
    m.redraw();
  }
}
function f720() {
  if (vA253.length > vA250.length) {
    const v4682 = vA253.length > 0 ? vA253[vA253.length - 1] : null;
    if (checkForMethod(v4682.toString())) {
      v4682();
    }
  }
  if (vA250.length > 0) {
    vA250.pop();
    vA251.pop();
    vA253.pop();
    if (!v4668) {
      v4667 = true;
      if (allowNavigation) {
        history.back();
      }
    }
    v4668 = false;
    const v4683 = vA252.pop();
    if (v4683 && v4683.onPop) {
      v4683.onPop();
    }
    m.redraw();
  }
}
export function checkForMethod(p5502) {
  return !!(vA253.length > 1) && p5502 != null && p5502.includes("setOverlay");
}
export function hardwareBackButtonPressed() {
  const v4684 = vA253.length > 0 ? vA253[vA253.length - 1] : null;
  if (vA253.length > 1 && v4684 != null) {
    v4684();
  }
}
export function addViewToHistoryStack(p5503) {
  vA253.push(p5503);
}
export function popViewFromHistoryStack() {
  vA253.pop();
}
window.addEventListener("keydown", e => {
  if (e.keyCode == 4 || e.key == "GoBack" || e.code == "KEYCODE_BACK") {
    e.preventDefault();
    hardwareBackButtonPressed();
  }
});
window.addEventListener("popstate", e => {
  e.preventDefault();
  if (!e.state || v4667) {
    v4667 = false;
  } else if (vA253.length > e.state.id && vA253.length > 1) {
    v4668 = true;
    hardwareBackButtonPressed();
    return;
  }
  if (e.state) {
    if (vA253.length < e.state.id) {
      v4667 = true;
      if (allowNavigation) {
        history.go(-1);
      }
    }
    return;
  } else {
    v4667 = true;
    if (allowNavigation) {
      history.go(1);
    }
    return;
  }
});
export function navigateBack() {
  f720();
}
export function navigateBackFrom(p5506) {
  if (clientExtensionBridge.d.getCurrentView() == p5506) {
    f720();
  }
}